import React from 'react';
import { Link } from 'react-router-dom';
import './BreadcrumbNav.css';

const BreadcrumbNav = ({ paths }) => {

  // Use a <nav> with an aria-label for accessibility.
  return (
    <nav className="breadcrumbs" aria-label="Breadcrumb">
      <ol className="breadcrumb-list">
        {/* <li className="breadcrumb-item">
          <Link to="/">Home</Link>
        </li> */}
        {paths.map((name, index) => {
          
          const isLast = index === paths.length - 1;
          let displayName = name;
          let pathname = name;

            if (name.split('/')[0] === 'Study') {
              displayName = 'Study';
              pathname = '/Study/' + name.split('/')[1];
            }

            if (name.split('/')[0] === 'Dashboard') {
              displayName = 'Home';
              pathname = '/Dashboard';
            }

            if (name.split('/')[0] === 'StudyDatasets') {
              displayName = 'Study Datasets';
              pathname = '/StudyDatasets/' + name.split('/')[1];
            }

            return (
            <li key={displayName} className="breadcrumb-item">
              {isLast ? (
              <span aria-current="page">{displayName}</span>
              ) : (
              <Link to={pathname}>{displayName}</Link>
              )}
            </li>
            );
        })}
      </ol>
    </nav>
  );
};

export default BreadcrumbNav;